import { _ as a } from "./index918.mjs";
import { _ as r } from "./index837.mjs";
var o = a, t = r, p = o(t, "Map"), v = p;
export {
  v as _
};
